export default __webpack_public_path__ + "static/media/GroupAndRemovingTokens.df37439d.mp4";